module.exports = __webpack_public_path__ + "static/media/28-7.dfb2acef.mp3";